import { render } from "./VerticalSidebar.vue?vue&type=template&id=ece65726&scoped=true"
import script from "./VerticalSidebar.vue?vue&type=script&lang=js"
export * from "./VerticalSidebar.vue?vue&type=script&lang=js"

import "./VerticalSidebar.vue?vue&type=style&index=0&id=ece65726&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece65726"]])

export default __exports__